import { createContext, useContext } from "react";

export const AppMenuContext = createContext<
  | {
      container: HTMLDivElement | null;
    }
  | undefined
>(undefined);

export const AppMenuContextProvider = AppMenuContext.Provider;

export const useAppMenuContext = () => {
  const context = useContext(AppMenuContext);

  if (!context) {
    throw new Error("AppMenuContext is not provided");
  }

  return context;
};
